import { usePortalVacationPreviewQuery } from "@dashboard/graphql";
import { Box, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { portalMessages as m } from "./messages";

const Figure = ({ label, value, tone }: { label: string; value: number; tone?: "critical1" }) => (
  <Box display="flex" flexDirection="column">
    <Text size={1} color="default2">
      {label}
    </Text>
    <Text size={5} fontWeight="bold" color={tone}>
      {value}
    </Text>
  </Box>
);

/** Working days of a requested range and, for vacations, the year's balance
 * before and after it (updates as the dates change). */
export const VacationPreview = ({
  start,
  end,
  vacation,
  userId,
}: {
  start: string;
  end: string;
  vacation: boolean;
  userId?: string;
}) => {
  const intl = useIntl();
  const valid = !!start && !!end && end >= start;
  const { data } = usePortalVacationPreviewQuery({
    variables: { start, end, userId },
    skip: !valid,
    fetchPolicy: "network-only",
  });
  const preview = data?.vacationPreview;

  if (!valid || !preview) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      padding={3}
      borderRadius={3}
      backgroundColor="default2"
    >
      <Text size={3} fontWeight="bold">
        {intl.formatMessage(m.previewDays, { count: preview.workingDays })}
      </Text>
      {vacation && (
        <Box display="flex" gap={6} flexWrap="wrap">
          <Figure
            label={intl.formatMessage(m.previewTotal, { year: preview.year })}
            value={preview.entitled}
          />
          <Figure label={intl.formatMessage(m.previewUsed)} value={preview.used} />
          <Figure label={intl.formatMessage(m.previewBooked)} value={preview.booked} />
          <Figure label={intl.formatMessage(m.previewThis)} value={preview.workingDays} />
          <Figure
            label={intl.formatMessage(m.previewRemaining)}
            value={preview.remainingAfter}
            tone={preview.remainingAfter < 0 ? "critical1" : undefined}
          />
        </Box>
      )}
      {vacation && preview.bonus > 0 && (
        <Text size={2} color="success1">
          {intl.formatMessage(m.bonusIfApproved, { days: preview.bonus })}
        </Text>
      )}
      {vacation && preview.error && (
        <Text size={2} color="critical1">
          {preview.error}
        </Text>
      )}
    </Box>
  );
};
